export default "__VITE_ASSET__DHnBlE5e__"